module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"lastInteractionDate":"Última interacción","not-avaliable-data":"No disponible","idNumber":"Rut"},"pe":{"lastInteractionDate":"Última interacción","not-avaliable-data":"No disponible","idNumber":"DNI/CE"},"br":{"lastInteractionDate":"Última interação","not-avaliable-data":"Não disponível","idNumber":"CPF"}}')
  delete Component.options._Ctor
}
